<script setup lang="ts">
	const loaderInfo = useLoader()
</script>

<template>
	<div class="relative">
		<shared-top-nav class="border-b px-0" />
		<div class="px-4 sm:px-0">
			<slot />
		</div>
		<loader
			v-model:loading="loaderInfo.Loading"
			:loader-text="loaderInfo.loadingText"
			class="lg:max-w-screen left-0 max-w-full lg:left-[unset]"
		/>
	</div>
</template>

<style scoped>
	body {
		background: #fff;
	}
</style>
